import {
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
  Text
} from "@chakra-ui/react";
import {
  GroupBase, Select as AutoComplete
} from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { EmpresaFilial } from "models/empresa_filial_type";
import { PessoaType } from "models/person_type";
import { OptionType } from "models/select_mode";
import { useLayoutEffect, useState } from "react";
import InputMask from "react-input-mask";

interface IPersonalData {
  error: boolean;
  brandStars: any;
  nomeRef: any;
  textColor: string;
  accountSelected: PessoaType | undefined;
  idTipoRef: any;
  classificacaoRef: any;
  documentoRef: any;
  razaoSocialRef: any;
  nomeFantasiaRef: any;
  inscricaoMunicipalRef: any;
  inscricaoEstadualRef: any;
  contribuinteRef: any;
  tipoPessoaList: ClientClassificationType[];
  classificacaoList: ClientClassificationType[];
  filial: PessoaType[];
  changeFilial : (item : any) => void;
  pessoaFilial: EmpresaFilial[];
}

const PersonalData = ({
  brandStars,
  error,
  nomeRef,
  textColor,
  accountSelected,
  classificacaoList,
  classificacaoRef,
  contribuinteRef,
  documentoRef,
  idTipoRef,
  inscricaoEstadualRef,
  inscricaoMunicipalRef,
  nomeFantasiaRef,
  razaoSocialRef,
  tipoPessoaList,
  filial,
  changeFilial,
  pessoaFilial
}: IPersonalData) => {
  const [mask, setMask] = useState("");
  const [enabled, setEnabled] = useState(true);

  const showInput = (selected: string) => {
    idTipoRef.current = selected;

    const filter = tipoPessoaList?.find((val) => val.id === selected);

    if (filter.nome.toLowerCase().includes("dica")) {
      setMask("99.999.999/9999-99");
    } else {
      setMask("999.999.999-99");
    }
  };

  const changeTipoPessoa = (item: string) => {
    let response = true;
    classificacaoRef.current = item;
    const filter = classificacaoList?.find((val) => val.id === item);
    if (
      filter?.nome.toLocaleLowerCase().includes("cliente") ||
      filter?.nome.toLocaleLowerCase().includes("ncia") ||
      filter?.nome.toLocaleLowerCase().includes("fornecedor")
    ) {
      response = false;
    }
    setEnabled(response);
  };

  useLayoutEffect(() => {
    if (accountSelected !== undefined) {
      if (accountSelected?.documento.length > 15) {
        setMask("99.999.999/9999-99");
      } else {
        setMask("999.999.999-99");
      }
      changeTipoPessoa(accountSelected?.classificacaoId);
    } else {
      setMask("999.999.999-99");
    }
  }, [accountSelected]);

  return (
    <AccordionItem>
      <h2>
        <AccordionButton>
          <Box flex="1" textAlign="left" color={"#422AFB"} fontWeight={"bold"}>
            Dados Cadastrais
          </Box>
          <AccordionIcon color={"#422AFB"} />
        </AccordionButton>
      </h2>
      <AccordionPanel pb={4}>
        <SimpleGrid columns={3} spacing={4}>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Classificação de Pessoa<Text color={brandStars}>*</Text>
            </FormLabel>

            <Select
              size="md"
              placeholder="Selecione a Classificação da Pessoa"
              defaultValue={accountSelected?.classificacaoId}
              onChange={(e) => changeTipoPessoa(e.target.value)}
              ref={classificacaoRef}
            >
              {classificacaoList?.map((item) => (
                <option
                  value={item.id}
                  key={item.id}
                  selected={item.id === accountSelected?.classificacaoId}
                >
                  {item.nome}
                </option>
              ))}
            </Select>
          </FormControl>
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Tipo de Pessoa<Text color={brandStars}>*</Text>
            </FormLabel>

            <Select
              size="md"
              placeholder="Selecione o Tipo da Pessoa"
              defaultValue={accountSelected?.idTipo}
              onChange={(e) => showInput(e.target.value)}
            >
              {tipoPessoaList?.map((item) => (
                <option
                  value={item.id}
                  key={item.id}
                  selected={item.id === accountSelected?.idTipo}
                >
                  {item.nome}
                </option>
              ))}
            </Select>
          </FormControl>

          <FormControl isInvalid={error}>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Nome<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              ref={nomeRef}
              defaultValue={accountSelected?.nome}
              isRequired={true}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o nome"
              onChange={(e) => (nomeRef.current = e.target.value)}
              fontWeight="500"
              isInvalid={error}
              size="md"
            />
            {error && (
              <FormErrorMessage>
                Preencha Corretamente o Campo Nome.
              </FormErrorMessage>
            )}
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Documento<Text color={brandStars}>*</Text>
            </FormLabel>
            <Input
              ref={documentoRef}
              defaultValue={accountSelected?.documento}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder={
                mask === "999.999.999-99" ? "Preencha o CPF" : "Preencha o CNPJ"
              }
              onChange={(e) => (documentoRef.current = e.target.value)}
              fontWeight="500"
              size="md"
              as={InputMask}
              mask={mask}
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Nome Fantasia
            </FormLabel>
            <Input
              ref={nomeFantasiaRef}
              defaultValue={accountSelected?.nomeFantasia}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha o nome fantasia"
              onChange={(e) => (nomeFantasiaRef.current = e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Razão Social
            </FormLabel>
            <Input
              ref={razaoSocialRef}
              defaultValue={accountSelected?.razaoSocial}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a razão social"
              onChange={(e) => (razaoSocialRef.current = e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>
        </SimpleGrid>
        <SimpleGrid columns={1} spacing={4} mt={4} mb={4}>
        <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Filial
            </FormLabel>

            <AutoComplete<OptionType, true, GroupBase<OptionType>>
                isDisabled={enabled}
                size="md"
                onChange={(e) => {
                  changeFilial(e)
                }}
                placeholder="Selecione as Filiais"
                name={"Filial"}
                tagVariant="solid"
                colorScheme="brand"
                isMulti
                value={
                  pessoaFilial.filter((val) => val.idFilial !== "0").map((pf) => {
                    return {
                      value: pf.idFilial,
                      label:  filial?.find((fl) =>  fl.id === pf.idFilial).nome
                    }
                  })
                }
                options={filial?.map((item) => {
                  return {
                    label: item.nome,
                    value: item.id,
                  };
                })}
              />
          </FormControl>

        </SimpleGrid>
        <SimpleGrid columns={3} spacing={4} mt={4}>
          
          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Inscrição Estadual
            </FormLabel>
            <Input
              ref={inscricaoEstadualRef}
              defaultValue={accountSelected?.inscricaoEstadual}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Inscrição Estadual"
              onChange={(e) => (inscricaoEstadualRef.current = e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Inscrição Municipal
            </FormLabel>
            <Input
              ref={inscricaoMunicipalRef}
              defaultValue={accountSelected?.inscricaoMunicipal}
              isRequired={false}
              fontSize="sm"
              ms={{ base: "0px", md: "0px" }}
              type="text"
              placeholder="Preencha a Inscrição Municipal"
              onChange={(e) => (inscricaoMunicipalRef.current = e.target.value)}
              fontWeight="500"
              size="md"
            />
          </FormControl>

          <FormControl>
            <FormLabel
              display="flex"
              ms="4px"
              fontSize="sm"
              fontWeight="500"
              color={textColor}
              mb="8px"
            >
              Contribuinte
            </FormLabel>

            <Select
              placeholder="Selecione um tipo de contribuinte"
              size="md"
              onChange={(e) => (contribuinteRef.current = e.target.value)}
              ref={contribuinteRef}
            >
              <option
                value="1"
                selected={accountSelected?.contribuinte === "1"}
              >
                1 - Contribuinte ICMS
              </option>
              <option
                value="2"
                selected={accountSelected?.contribuinte === "2"}
              >
                2 - Contribuinte isento de Inscrição no Cadastro de
                Contribuintes
              </option>
              <option
                value="9"
                selected={accountSelected?.contribuinte === "9"}
              >
                9 - Não contribuinte, que pode ou não possuir Inscrição Estadual
                no Cadastro de Contribuintes
              </option>
            </Select>
          </FormControl>
        </SimpleGrid>
      </AccordionPanel>
    </AccordionItem>
  );
};

export default PersonalData;
